var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bgImg"},[_c('img',{staticClass:"loginLogo",attrs:{"src":require("../../assets/common/logo02.jpg"),"alt":""}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"loginBtn",on:{"click":_vm.getAuthUrl}},[_vm._v("微信登录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344438d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/wx-auth.vue
// module id = null
// module chunks = 